import React, { FC } from 'react';
import { SCUICollapsiblePaper } from '../../../../../atomic/molecules';
import { Grid } from '@mui/material';
import Swal from 'sweetalert2';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';

export const SCUIBillingErrorLogDrawerContent: FC<{
    message: any;
    onClose?: any;
    trackingMessage: any;
    guid: any;
}> = ({ message, trackingMessage, onClose, guid }) => {
    const { t } = useTranslation();

    function handleCopy(id: any) {
        try {
            let copyText = document.getElementById(id)?.innerText;
            if (copyText) {
                navigator.clipboard.writeText(copyText);
                Swal.fire({
                    icon: 'success',
                    title: t('general.copied'),
                    showConfirmButton: false,
                    timer: 1500,
                });
            }
        } catch (error) {
            console.error('Copy failed:', error);
        }
    }

    // Add safety checks
    if (!t) {
        return <div>Loading...</div>;
    }

    return (
        <Grid className="billing-error-log-drawer">
            <Grid className="billing-error-log-drawer-header" container sx={{ paddingTop: '2rem' }}>
                <Grid
                    className="billing-error-log-drawer-title"
                    sx={{ paddingLeft: '1rem' }}
                    size={{
                        md: 11.5,
                        xs: 11.5,
                        lg: 11.5,
                    }}
                >
                    <h1 className="headtxt">id: {guid || 'N/A'}</h1>
                </Grid>

                <Grid
                    className="billing-error-log-drawer-close"
                    size={{
                        md: 0.5,
                        xs: 0.5,
                        lg: 0.5,
                    }}
                >
                    <CloseIcon
                        className="svg_icons billing-error-log-drawer-close-button"
                        onClick={onClose}
                    />
                </Grid>
            </Grid>
            <Grid className="billing-error-log-drawer-message" sx={{ margin: '2rem' }}>
                {message && (
                    <SCUICollapsiblePaper
                        iconTooltip={t('general.copyToClipboard')}
                        icon={'fi-rr-copy'}
                        iconOnClick={() => handleCopy('sendInvoice')}
                        paperText={t('general.message')}
                        open={true}
                        withoutMargin
                        changeColorWhenOpen
                    >
                        <pre id="sendInvoice" className="jsonViewDiv">
                            {message}
                        </pre>
                    </SCUICollapsiblePaper>
                )}
            </Grid>
            <Grid
                className="billing-error-log-drawer-tracking"
                size={{
                    md: 12,
                    xs: 12,
                }}
            >
                <div className="sideBySideDiv billing-error-log-drawer-tracking-content">
                    <p className="txtDetailForDrawerTitle">{t('general.trackingMessage')}</p>
                    <p className="txtDetailForDrawerContent">{trackingMessage || 'N/A'}</p>
                </div>
            </Grid>
        </Grid>
    );
};
